var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Account"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0333 26.6333C33.1333 24.6667 33.75 22.4 33.75 20C33.75 12.4167 27.5833 6.25 20 6.25C12.4167 6.25 6.25 12.4167 6.25 20C6.25 22.4 6.86666 24.6667 7.94999 26.6333C8.04997 26.5167 8.14994 26.4167 8.24992 26.3167L8.24999 26.3167C9.33333 25.2333 10.8333 24.6167 12.3833 24.6167H27.6167C29.3333 24.6167 30.95 25.3833 32.0333 26.6333ZM19.9995 33.7492C24.2161 33.7492 27.9995 31.8326 30.5328 28.8326C29.9661 27.7992 28.8328 27.1159 27.6161 27.1159H12.3828C11.4828 27.1159 10.6328 27.4659 10.0161 28.0826C9.79948 28.2992 9.59948 28.5492 9.46615 28.8326C11.9828 31.8326 15.7661 33.7492 19.9995 33.7492Z",
    fill: "#D58B0E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.9833 29.0167C31.4 27.1833 29.65 25.85 27.6333 25.85H12.3833C11.1333 25.85 9.96667 26.35 9.13333 27.1833C8.63333 27.6833 8.23333 28.3333 8.03333 29.0167C8.03333 29.0333 8.03333 29.0333 8.03333 29.0333M25.3333 15.95C25.3333 18.9 22.95 21.2833 20 21.2833C17.05 21.2833 14.6667 18.9 14.6667 15.95C14.6667 13 17.05 10.6167 20 10.6167C22.95 10.6167 25.3333 13 25.3333 15.95ZM20 5C11.7167 5 5 11.7167 5 20C5 28.2833 11.7167 35 20 35C28.2833 35 35 28.2833 35 20C35 11.7167 28.2833 5 20 5Z",
    stroke: "#D58B0E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.e89daeb4a1f40c84f2abc19c0ee80390.svg";
export { ForwardRef as ReactComponent };